import React from 'react';

import { IoMdHelp } from 'react-icons/io';
import { Spinner } from 'react-bootstrap';

import './Tour.css';

import PropTypes from 'prop-types';

const CustomBeacon = ({ onClick, onMouseEnter, title }) => {
  return (
    <>
      <div
        aria-label="Open the dialog"
        title={title}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
      >
        <Spinner animation="grow" variant="info" />
        <IoMdHelp
          onClick={onClick}
          className="bounce"
          style={{ 'margin-left': '-24px' }}
        />{' '}
      </div>
    </>
  );
};

CustomBeacon.propTypes = {
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  title: PropTypes.string
};

const tourSteps = [
  {
    target: '#upload-col',
    content: 'You can upload a guideline to share it with other users...'
  },
  {
    target: '#search-col',
    content: 'or search guidelines that have already been uploaded.'
  },

  {
    target: '#search-form',
    content: (
      <>
        This input allows you to search the <b>text inside</b> a document...
      </>
    )
  },
  {
    target: '#filter-form',
    content: (
      <>
        whereas this input allows you to search the{' '}
        <b>filename, title, or organisation name</b>
      </>
    )
  },
  {
    target: '#scatterplotSVG',
    content: (
      <>
        <p>
          Each dot in this plot represents a document. They are arranged so that
          similar documents are close together.
        </p>
        <p>
          Documents are assigned to a <i>cluster</i>, and coloured accordingly.
          You can mouse-over a document to see its title, or click to open it.
        </p>
      </>
    )
  },
  {
    target: '.react-pdf__Page > canvas',
    content: 'This is a preview of the selected document.'
  },
  {
    target: '.open-pdf-file-from-preview',
    content: 'Clicking here opens the PDF file in a new browser window'
  },
  {
    target: '#results-tabs-tabpane-clusters',
    content:
      'This is a list of all documents (or the documents matching a search), grouped by cluster.'
  },

  {
    target: '#results-tabs-tab-table',
    content: 'This tab switches to a tabular view of the documents'
  },

  {
    target: '.cluster-keywords',
    content: 'These are the most important keywords for each cluster'
  },
  {
    target: '.cluster-count-bar',
    content: 'This bar shows the number of documents in each cluster'
  },
  {
    target: '.cluster-color-rect',
    content:
      'Clicking here highlights the documents in this cluster on the scatterplot'
  },
  {
    target: '.toggle-cluster-collapsed',
    content:
      'Clicking here expands/collapses the list of documents in this cluster. You can then preview a document (by clicking the View button), open it in a new tab (by clicking the PDF icon), or show related documents.',
    expandCluster: true
  }
  /*
  {
    target: '.cluster-pdf-open-button',
    content: 'Clicking here opens PDF in a new tab'
  },
  {
    target: '.cluster-pdf-preview-button',
    content: 'Clicking here opens PDF as preview in the bottom-right'
  }
     */
];

export { tourSteps, CustomBeacon };
